<script>
	import Data from "../controladores/data.svelte";
	let controlador;
	let nombre = "",documento = "",telefono = "",email = "",direccion = "";
	async function agregar(){
		if (documento !== ""){
		await controlador.agregarCliente(documento,nombre,telefono,email,direccion);
		}
	}
</script>
<Data bind:this={controlador}/>
<div class="flex flex-col items-center justify-start bg-purple-300 w-screen h-full max-w-full min-h-screen">
	<h1 class="text-xl font-bold">Agregar Cliente</h1>
	<div class="flex flex-col items-center justify-start w-3/4 h-auto">
		<div class="flex w-full items-center">
			<l class="ri-user-line"/><input bind:value={nombre} class="full p-2 m-4 w-full" placeholder="Nombre y Apellido"/>
				<i class="ri-account-box-line"/> <input  bind:value={documento} class="full p-2 m-4 w-full" placeholder="Documento"/>
		</div>
		<div class="flex w-full items-center">
		<i class="ri-phone-line "/><input bind:value={telefono} class="full p-2 m-4 w-full" placeholder="Telefono +5411..."/>
		<i class="ri-mail-line" /><input  bind:value={email} class="full p-2 m-4 w-full" placeholder="Email"/>
		</div>
		<div class="flex w-full items-center">
			<i class="ri-map-pin-line"/><input bind:value={direccion} class="full p-2 m-4 w-full" placeholder="Dirección"/>
		</div>
		<div class="flex w-full items-center justify-around">
			<a class="p-2 m-4 bg-purple-500 text-white flex items-center justify-center rounded" href="#/home">Volver</a>
			<button on:click={agregar} class="p-2 m-4 bg-purple-500 text-white flex items-center justify-center rounded">Agregar</button>
		</div>
	</div>
</div>
